import styled from 'styled-components'

export const CenterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const LogoutIcon = styled.div`
  margin-right: 10px;
  && {
    font-size: 24px;
  }
`
